import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function PoolCleanerSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("roboticPoolCleaner.title")}</title>
        <meta name="keywords" content={t("roboticPoolCleaner.keywords")} />
        <meta name="description" content={t("roboticPoolCleaner.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#0c4a6e]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/robotPool5.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_-4%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#082f49]/92 via-[#082f49]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("roboticPoolCleaner.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("roboticPoolCleaner.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("roboticPoolCleaner.knowledgeBase.rootLabel")}
        rootColor="#0284c7"
        treeTranslationKey="roboticPoolCleaner.knowledgeBase.tree"
        i18nPrefix="roboticPoolCleaner.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="roboticPoolCleaner"
        images={{
          painPoints: "/solutions/robotPool4.jpeg",
          solutions: "/solutions/robotPool3.jpeg",
          cta: "/solutions/robotPool1.jpeg",
        }}
        imagesPos={{
          cta: "50% 25%",
        }}
      />
    </>
  );
}
